import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../../core/state/entity.state';
import {
  LearningSectionContainerEntityState
} from '../../../learning-section/learning-section-container/services/learning-section-container.entity.service';
import { ExplanationContentEntity } from '../explanation-content-entity';

export const STATE_NAME = 'explanationContentEntity';

export const ExplanationContentEntityState: GenericEntityStateClass<ExplanationContentEntity> =
  createEntityState<ExplanationContentEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ExplanationContentEntityService extends EntityService<ExplanationContentEntity> {
  private learningSectionContainerService = inject(LearningSectionContainerEntityState);

  constructor() {
    super();
    this.resourceType = 'explanation-contents';
    this.stateClass = ExplanationContentEntityState;

    this.registerRelation('learning-section-containers', this.learningSectionContainerService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state: any) => {
      const slice = state[STATE_NAME];
      return this.stateClass.allByQuery(slice, { query });
    };
  }
}
